export const SINGLE_PIECE = 1;
export const SINGLE_PIECE_PER_NEXT_OPERATION_UNIT = 1;

const sect = {};
sect.SECT_HEADER = 'sect_header';
sect.SECT_INSTANCE = 'sect_instance'; // polja koja ne uticu na ident
sect.SECT_GENUS = 'sect_genus'; // polja koja uticu na genus tj. ident
sect.SECT_FIXED = 'sect_fixed'; // sect za fixed_fields
sect.SECT_DB = 'sect_db'; // polja koja se koriste samo u bazi podataka
sect.SECT_FRONTEND = 'sect_frontend'; // polja koja se koriste samo na formama u frontendu
sect.SECT_NESVRSTANI = 'sect_NESVRSTANI'; // za polja za koja nije jos odluceno

/*
// OLD
// sect.DEFAULT_ = 'default'; // ???
sect.SECT_OWN = 'sect_own'; // prebacen je pods_own
sect.SECT_INPUT = 'sect_input'; // prebacen je u pods_input
sect.SECT_DER = 'sect_der'; // prebacen je u pods_der
sect.SECT_SPECIMEN = 'sect_specimen'; // instanca, pripadnik vrste, primerak, specimen...
// sect.SECT_IGNORE = 'sect_ignore'; // frontend only polje. ignorise se na backendu
sect.SECT_EXTRA = 'sect_extra'; // ???
*/


export { sect };
// exports.sect = sect; // Node.js named export